<template>
  <div class="d-flex flex-wrap align-items-center entity-excel-toolbar">
    <b-button
      variant="outline-secondary"
      size="sm"
      class="mr-50 mb-50"
      :disabled="templateLoading"
      @click="downloadTemplate"
    >
      <span v-if="templateLoading">…</span>
      <span v-else>قالب Excel</span>
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      class="mr-50 mb-50"
      :disabled="exporting"
      @click="downloadExport"
    >
      <span v-if="exporting">…</span>
      <span v-else>تصدير</span>
    </b-button>
    <b-form-file
      v-model="file"
      size="sm"
      accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      placeholder="استيراد"
      class="mb-50 entity-excel-file"
      style="max-width: 200px"
    />
    <b-button
      variant="success"
      size="sm"
      class="mb-50"
      :disabled="!file || importing"
      @click="runImport"
    >
      <span v-if="importing">…</span>
      <span v-else>استيراد</span>
    </b-button>
  </div>
</template>

<script>
import { BButton, BFormFile } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import dataExchangeApi from "@/apiServices/dataExchangeApi";

export default {
  name: "EntityExcelToolbar",
  components: { BButton, BFormFile },
  props: {
    /** Backend key: categories, courses, lessons, … */
    entity: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      file: null,
      exporting: false,
      templateLoading: false,
      importing: false,
    };
  },
  methods: {
    async downloadTemplate() {
      this.templateLoading = true;
      try {
        const res = await dataExchangeApi.downloadEntityTemplate(this.entity);
        const blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `osama-template-${this.entity}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.$toast({
          component: ToastificationContent,
          props: { title: "تم تنزيل القالب", variant: "success" },
        });
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: e.response?.data?.message || e.message || "فشل تنزيل القالب",
            variant: "danger",
          },
        });
      } finally {
        this.templateLoading = false;
      }
    },
    async downloadExport() {
      this.exporting = true;
      try {
        const res = await dataExchangeApi.exportEntity(this.entity);
        const blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `osama-export-${this.entity}-${Date.now()}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.$toast({
          component: ToastificationContent,
          props: { title: "تم التصدير", variant: "success" },
        });
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: e.response?.data?.message || e.message || "فشل التصدير",
            variant: "danger",
          },
        });
      } finally {
        this.exporting = false;
      }
    },
    async runImport() {
      if (!this.file) return;
      this.importing = true;
      try {
        const res = await dataExchangeApi.importEntity(this.entity, this.file);
        const report = res.data?.data || res.data;
        const errCount = report?.errors?.length || 0;
        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              errCount > 0
                ? `اكتمل مع ${errCount} أخطاء — راجع الاستجابة`
                : "اكتمل الاستيراد",
            variant: errCount > 0 ? "warning" : "success",
          },
        });
        this.file = null;
        this.$emit("imported", report);
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: e.response?.data?.message || e.message || "فشل الاستيراد",
            variant: "danger",
          },
        });
      } finally {
        this.importing = false;
      }
    },
  },
};
</script>

<style scoped>
.entity-excel-toolbar ::v-deep .custom-file-label {
  height: 31px;
  line-height: 1.1;
  padding-top: 0.35rem;
  font-size: 0.857rem;
}
</style>
